"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _apiCallFactory = require("../apiService/apiCallFactory");

var _core = require("@material-ui/core");

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Sort = _interopRequireDefault(require("@material-ui/icons/Sort"));

require("react-virtualized/styles.css");

require("./styles/react-virtualize-override.css");

var _reactVirtualized = require("react-virtualized");

var _VirtualAutoComplete = _interopRequireDefault(require("./VirtualAutoComplete"));

var _reducer = require("./reducer");

var _columns = require("./configuration/columns");

var ACTION_TYPES = _interopRequireWildcard(require("./actionTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      width: "100%",
      height: "100%"
    },
    rowClassName: {
      fontSize: "small"
    },
    autoSizerRoot: {
      flexGrow: 1,
      border: "1px solid #bdbdbd",
      marginTop: "16px",
      padding: "8px"
    },
    flippedSvgIcon: {
      transform: "scale(1, -1)"
    }
  };
});
var FancyButton = (0, _core.withStyles)({
  root: {
    minWidth: "175px",
    maxWidth: "200px",
    margin: "4px 0"
  }
})(_Button.default);
var PRODUCT_FIELDS = ["oeProductID", "partTerminologyID", "partTerminologyName", "categoryID", "categoryName", "subCategoryID", "subCategoryName", "region", "availability", "oeCategory", "price"];

var ProductChooser = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var innerRef = (0, _react.useRef)(ref);
  var tableRef = (0, _react.useRef)();
  var classes = useStyle();

  var _useReducer = (0, _react.useReducer)(_reducer.reducer, _reducer.initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var dispatchToState = function dispatchToState(type, payload) {
    return dispatch({
      type: type,
      payload: payload
    });
  };

  var oeProducts = state.oeProducts,
      sortBy = state.sortBy,
      sortDirection = state.sortDirection,
      research = state.research,
      selectedItems = state.selectedItems,
      showOEProductOnly = state.showOEProductOnly,
      filters = state.filters,
      externalInfo = state.externalInfo;
  var _props$setSelectedPro = props.setSelectedProducts,
      setSelectedProducts = _props$setSelectedPro === void 0 ? function (d) {} : _props$setSelectedPro,
      _props$initialSelecte = props.initialSelectedProducts,
      initialSelectedProducts = _props$initialSelecte === void 0 ? [] : _props$initialSelecte,
      axiosInstance = props.axiosInstance,
      _props$showAppendAllB = props.showAppendAllButton,
      showAppendAllButton = _props$showAppendAllB === void 0 ? true : _props$showAppendAllB;
  (0, _react.useEffect)(function () {
    (0, _apiCallFactory.fetchAllProduct)(axiosInstance, function (data) {
      if (data) {
        dispatchToState(ACTION_TYPES.SET_OE_PRODUCTS, data);
      }
    });
  }, []);
  (0, _react.useEffect)(function () {
    var initialSelectedItems = [];
    var externalInfo = new Map();
    initialSelectedProducts.forEach(function (item) {
      var resolvedProductKey = resolveProductKey(item);
      initialSelectedItems.push(resolvedProductKey);
      var externalInfoForItem = {};
      Object.keys(item).filter(function (itemKey) {
        return !PRODUCT_FIELDS.includes(itemKey);
      }).forEach(function (itemKey) {
        return externalInfoForItem[itemKey] = item[itemKey];
      });
      externalInfo.set(resolvedProductKey, externalInfoForItem);
    });
    var payload = {
      selectedItems: initialSelectedItems,
      externalInfo: externalInfo
    };
    dispatchToState(ACTION_TYPES.SET_SELECTED_ITEMS_AND_EXTERNAL_INFO, payload);
  }, [initialSelectedProducts]);
  (0, _react.useEffect)(function () {
    var effectiveProducts = oeProducts.filter(function (item) {
      return resolveIfProductFilteredIn(item);
    });
    var productIDs = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.partTerminologyID + "";
    }).sort()));
    var products = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.partTerminologyName;
    }).sort()));
    var categories = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.categoryName;
    }).sort()));
    var subCategories = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.subCategoryName;
    }).sort()));
    var regions = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.region ? item.region : "(Blank)";
    }).sort()));
    var availabilities = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.availability ? item.availability : "(Blank)";
    }).sort()));
    var oeCategories = Array.from(new Set(effectiveProducts.map(function (item) {
      return item.oeCategory ? item.oeCategory : "(Blank)";
    }).sort()));
    dispatchToState(ACTION_TYPES.SET_FILTERS, {
      partTerminologyID: productIDs,
      partTerminologyName: products,
      categoryName: categories,
      subCategoryName: subCategories,
      region: regions,
      availability: availabilities,
      oeCategory: oeCategories
    });
  }, [showOEProductOnly, oeProducts, research]);

  var sort = function sort(item1, item2) {
    var item1IsChecked = resolveIfProductChecked(item1);
    var item2IsChecked = resolveIfProductChecked(item2);

    if (item1IsChecked && !item2IsChecked) {
      return -1;
    } else if (!item1IsChecked && item2IsChecked) {
      return 1;
    }

    if (item1[sortBy] === null && item2[sortBy] == null) {
      return 0;
    }

    if (item1[sortBy] === null || item2[sortBy] == null) {
      if (sortDirection === _reactVirtualized.SortDirection.DESC) {
        return item2[sortBy] === null ? 1 : -1;
      }

      return item1[sortBy] === null ? 1 : -1;
    }

    if (typeof item1[sortBy] === 'number') {
      if (sortDirection === _reactVirtualized.SortDirection.DESC) {
        return item2[sortBy] - item1[sortBy];
      }

      return item1[sortBy] - item2[sortBy];
    } else if (typeof item1[sortBy] === 'boolean') {
      return sortDirection === _reactVirtualized.SortDirection.DESC ? item1[sortBy] ? 1 : -1 : item2[sortBy] ? -1 : 1;
    } else {
      if (sortDirection === _reactVirtualized.SortDirection.DESC) {
        return item2[sortBy].localeCompare(item1[sortBy]);
      }

      return item1[sortBy].localeCompare(item2[sortBy]);
    }
  };

  var updateSelectedItems = function updateSelectedItems(event, partTerminologyID, oeProductID) {
    var updatedSelectedItems = _toConsumableArray(selectedItems);

    var key = resolveProductKey({
      partTerminologyID: partTerminologyID,
      oeProductID: oeProductID
    });

    if (event.target.checked) {
      updatedSelectedItems.push(key);
    } else {
      updatedSelectedItems.splice(updatedSelectedItems.indexOf(key), 1);
    }

    dispatchToState(ACTION_TYPES.SET_SELECTED_ITEMS, updatedSelectedItems);
  };

  var onClickSelect = function onClickSelect() {
    var selectedProducts = oeProducts.filter(function (item) {
      return resolveIfProductChecked(item);
    }).map(function (item) {
      var productKey = resolveProductKey(item);

      if (externalInfo.has(productKey)) {
        return _objectSpread(_objectSpread({}, item), externalInfo.get(productKey));
      }

      return item;
    });
    setSelectedProducts(selectedProducts);
  };

  var resolveIfProductChecked = function resolveIfProductChecked(oeProduct) {
    var key = resolveProductKey(oeProduct);
    return selectedItems.indexOf(key) >= 0;
  };

  var resolveIfProductFilteredIn = function resolveIfProductFilteredIn(product) {
    if (resolveOEProductOnly(product)) {
      return resolveResearch(product);
    }

    return false;
  };

  var resolveOEProductOnly = function resolveOEProductOnly(product) {
    if (showOEProductOnly && !product["oeProductID"]) {
      return false;
    }

    return true;
  };

  var resolveResearch = function resolveResearch(product) {
    var researchKeys = Object.keys(research);
    return researchKeys.map(function (item) {
      if (item in product) {
        var toCompare = (product[item] + "").replace("null", "(Blank)");

        if (Array.isArray(research[item]) && toCompare) {
          if (research[item].length === 0) {
            return true;
          }

          var researchForItem = research[item].map(function (s) {
            return s.toLowerCase();
          });
          return researchForItem.indexOf(toCompare.toLowerCase()) >= 0;
        } else if (toCompare) {
          if (research[item].length === 0) {
            return true;
          }

          var researchSplit = research[item].split(/\s{1,}/);
          return researchSplit.filter(function (r) {
            return toCompare.toLowerCase().indexOf(r.toLowerCase()) >= 0;
          }).length === researchSplit.length;
        } else {
          return research[item].length === 0;
        }
      }

      return true;
    }).filter(function (v) {
      return v === false;
    }).length === 0;
  };

  var resolveProductKey = function resolveProductKey(product) {
    return product.partTerminologyID + ":" + (product.oeProductID ? product.oeProductID : "null");
  };

  var appendAll = function appendAll() {
    var updatedSelectedItems = _toConsumableArray(selectedItems);

    oeProducts.filter(function (item) {
      return resolveIfProductFilteredIn(item);
    }).map(function (item) {
      return resolveProductKey(item);
    }).forEach(function (key) {
      if (updatedSelectedItems.indexOf(key) < 0) {
        updatedSelectedItems.push(key);
      }
    });
    dispatchToState(ACTION_TYPES.SET_SELECTED_ITEMS, updatedSelectedItems);
  };

  var resetResearch = function resetResearch() {
    dispatchToState(ACTION_TYPES.RESET_RESEARCH);
  };

  var unselectAll = function unselectAll() {
    dispatchToState(ACTION_TYPES.SET_SELECTED_ITEMS, []);
  };

  var unAppendAll = function unAppendAll() {
    var updatedSelectedItems = _toConsumableArray(selectedItems);

    oeProducts.filter(function (item) {
      return resolveIfProductFilteredIn(item);
    }).map(function (item) {
      return resolveProductKey(item);
    }).forEach(function (key) {
      if (updatedSelectedItems.indexOf(key) >= 0) {
        updatedSelectedItems.splice(updatedSelectedItems.indexOf(key), 1);
      }
    });
    dispatchToState(ACTION_TYPES.SET_SELECTED_ITEMS, updatedSelectedItems);
  };

  var updateShowOEProductOnly = function updateShowOEProductOnly(event) {
    var checked = event.target.checked;
    dispatchToState(ACTION_TYPES.SET_SHOW_OE_PRODUCTS_ONLY, checked);
  };

  var scrollToTop = function scrollToTop() {
    if (tableRef) {
      tableRef.current.scrollToRow(0);
    }
  };

  var effectiveProducts = oeProducts.filter(resolveOEProductOnly);
  var sortedOeProducts = effectiveProducts.filter(resolveResearch).sort(sort);
  var hasResearch = Object.keys(research).filter(function (item) {
    return research[item].length > 0;
  }).length > 0;
  var isAppendAll = (hasResearch || showOEProductOnly) && sortedOeProducts.filter(function (item) {
    return selectedItems.indexOf(resolveProductKey(item)) < 0;
  }).length === 0;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: innerRef,
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: showOEProductOnly,
      onChange: updateShowOEProductOnly
    }),
    label: "Show Available Product Lines Only"
  })), /*#__PURE__*/_react.default.createElement("div", null, showAppendAllButton && /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      checked: isAppendAll,
      onChange: isAppendAll ? unAppendAll : appendAll
    }),
    disabled: !hasResearch && !showOEProductOnly,
    label: "Append All to selection"
  }))), /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(FancyButton, {
    variant: "outlined",
    onClick: unselectAll
  }, "Clear Selection"), /*#__PURE__*/_react.default.createElement(FancyButton, {
    variant: "outlined",
    onClick: resetResearch
  }, "Clear Filters"))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.autoSizerRoot
  }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, null, function (_ref) {
    var height = _ref.height,
        width = _ref.width;
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Table, {
      width: width,
      height: height,
      rowHeight: 25,
      headerHeight: 75,
      headerClassName: classes.rowClassName,
      rowClassName: classes.rowClassName,
      rowCount: sortedOeProducts.length,
      rowGetter: function rowGetter(_ref2) {
        var index = _ref2.index;

        var rowData = _objectSpread({}, sortedOeProducts[index]);

        return _objectSpread(_objectSpread({}, rowData), {}, {
          checked: resolveIfProductChecked(rowData)
        });
      },
      sortBy: sortBy,
      sortDirection: sortDirection,
      ref: tableRef
    }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      disableSort: true,
      cellRenderer: function cellRenderer(_ref3) {
        var rowData = _ref3.rowData;
        return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          size: "small",
          color: "primary",
          value: rowData.checked,
          checked: rowData.checked,
          onChange: function onChange(e) {
            return updateSelectedItems(e, rowData.partTerminologyID, rowData.oeProductID);
          }
        });
      },
      dataKey: "checked",
      width: 40,
      "aria-label": "checked"
    }), _columns.columnsConfiguration.map(function (configuration, key) {
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, _extends({
        key: key
      }, configuration, {
        disableSort: true,
        "aria-label": configuration.dataKey,
        headerRenderer: function headerRenderer(params) {
          return /*#__PURE__*/_react.default.createElement(ColumnComboBoxHeader, _extends({}, params, configuration.headerProps, {
            research: research,
            options: filters[params.dataKey],
            setSelected: function setSelected(selected) {
              return dispatchToState(configuration.researchDispatchKey, selected);
            },
            setSort: function setSort() {
              return dispatchToState(ACTION_TYPES.SET_SORT_OPTIONS, params.dataKey);
            }
          }));
        }
      }));
    }));
  })), /*#__PURE__*/_react.default.createElement(_Box.default, {
    margin: "16px 0",
    display: "flex",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(FancyButton, {
    variant: "outlined",
    onClick: scrollToTop
  }, "Back to Top"), /*#__PURE__*/_react.default.createElement(FancyButton, {
    variant: "outlined",
    onClick: onClickSelect
  }, "Select"))));
});

var ColumnComboBoxHeader = function ColumnComboBoxHeader(props) {
  var sortDirection = props.sortDirection,
      sortBy = props.sortBy,
      dataKey = props.dataKey,
      setSort = props.setSort,
      _props$withAutoComple = props.withAutoComplete,
      withAutoComplete = _props$withAutoComple === void 0 ? true : _props$withAutoComple;
  var classes = useStyle();
  var style = dataKey === sortBy && sortDirection === _reactVirtualized.SortDirection.DESC ? classes.flippedSvgIcon : undefined;
  var boxJustifyContent = withAutoComplete ? "space-between" : "center";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: boxJustifyContent,
    minHeight: 58,
    minWidth: 38
  }, withAutoComplete && /*#__PURE__*/_react.default.createElement(_Box.default, {
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(ColumnAutocomplete, props)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: setSort,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Sort.default, {
    fontSize: "small",
    className: style
  }))));
};

var ColumnAutocomplete = function ColumnAutocomplete(props) {
  var label = props.label,
      options = props.options,
      research = props.research,
      dataKey = props.dataKey,
      _props$isLast = props.isLast,
      isLast = _props$isLast === void 0 ? false : _props$isLast,
      _props$withCheckbox = props.withCheckbox,
      withCheckbox = _props$withCheckbox === void 0 ? true : _props$withCheckbox,
      setSelected = props.setSelected;
  var popperPlacement = isLast ? "bottom-end" : "bottom-start";
  var effectiveResearch = research[dataKey];

  var onChange = function onChange(event, value) {
    setSelected(withCheckbox ? value.sort() : value);
  };

  return /*#__PURE__*/_react.default.createElement(_VirtualAutoComplete.default, {
    multiple: withCheckbox,
    size: "small",
    options: options,
    disableCloseOnSelect: withCheckbox,
    PopperComponent: function PopperComponent(props) {
      return /*#__PURE__*/_react.default.createElement(_Popper.default, _extends({}, props, {
        style: _objectSpread(_objectSpread({}, props.style), {}, {
          minWidth: 250
        }),
        placement: popperPlacement
      }));
    },
    onChange: onChange,
    onInputChange: !withCheckbox ? onChange : function (e) {},
    clearOnBlur: false,
    renderOption: function renderOption(option, _ref4) {
      var selected = _ref4.selected;
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        display: "flex",
        alignItems: "center"
      }, withCheckbox && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        size: "small",
        checked: selected
      }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        style: {
          fontSize: "small"
        }
      }, option === null || option === void 0 ? void 0 : option.key));
    },
    renderInput: function renderInput(params) {
      var newValue = withCheckbox ? effectiveResearch.length ? "Filtered" : "" : effectiveResearch;

      var modifiedParams = _objectSpread(_objectSpread({}, params), {}, {
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          startAdornment: undefined
        })
      });

      return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, modifiedParams, {
        label: label,
        InputLabelProps: {
          shrink: true
        },
        size: "small",
        inputProps: _objectSpread(_objectSpread({}, params.inputProps), {}, {
          style: {
            fontSize: "small",
            marginTop: 3,
            color: "red"
          },
          value: newValue
        })
      }));
    }
  });
};

var _default = ProductChooser;
exports.default = _default;